export default __webpack_public_path__ + "static/media/backArrow.490305e0.svg";